import { BookingStoreNamespace } from "../../modules/booking/store";
import { DistributionStoreNamespace } from "../../modules/distribution/store/index";
import {
  RELATED_CONTACTS,
  UPDATE_CONTACT_RELATION,
  VENUE_RELATED_CONTACTS,
  BDContactRelations
} from "../../modules/booking/store/types";
import {
  ContactSearchTypes,
  contactSearchGetters
} from "./models/contact-search-types";
import { ContactStoreNamespace } from "../../modules/contacts/store";
import { SelectedContactRelatedContacts } from "../../modules/contacts/store/types";
import { CatalogStoreNamespace } from "../../modules/catalog/store";
import { RoyaltyStoreNamespace } from "../../modules/royalty/store";
import { AccountingStoreNamespace } from "../../modules/accounting/store";
import { LicenceStoreNamespace } from "../../modules/licensing/store";
import {
  ReleaseRelatedContacts,
  ArtistRelatedContacts,
  LabelRelatedContacts,
  ProjectRelatedContacts
} from "../../modules/catalog/store/types";
import {
  AccountsRelatedContacts,
} from "../../modules/royalty/store/types";

import {
  LicenceAccountRelatedContacts
} from "../../modules/licensing/store/types";
import {
  RoyaltyAccountsMainContacts
} from "../../modules/royalty/store/types";
import {
  LicenceInvoiceContact
} from "../../modules/licensing/store/types";
import {
  AccountingCostsContacts
} from "../../modules/accounting/store/types";
import {
  DistributionContact, SupplierRelatedContacts, DistributionOrderInvoiceContact,
  DistributionAccountRelatedContacts, DistributionOrderDeliveryAddress,
  DistributionAccountInvoiceContact, DistributionAccountDeliveryAddress,
  DistributionSupplierInvoiceContact, DistributionSupplierDeliveryAddress
} from "../../modules/distribution/store/types"


export const AddContactRelationDict = {
  artists: `${BookingStoreNamespace}/${RELATED_CONTACTS.SET.ALL}`,
  // account: `${DistributionStoreNamespace}/${RELATED_CONTACTS.SET.ALL}`,
  calendar_dates: `${BookingStoreNamespace}/${BDContactRelations.SET.ALL}`,
  booking_locations: `${BookingStoreNamespace}/${VENUE_RELATED_CONTACTS.UPDATE.ALL
    }`,
  contacts_individual: `${ContactStoreNamespace}/${SelectedContactRelatedContacts.SET.ALL
    }`,
  contacts: `${ContactStoreNamespace}/${SelectedContactRelatedContacts.SET.ALL
    }`,
  release: `${CatalogStoreNamespace}/${ReleaseRelatedContacts.SET.ALL}`,
  royalty_account: `${RoyaltyStoreNamespace}/${AccountsRelatedContacts.SET.ALL}`,
  //l_royalty_accounts:`${RoyaltyStoreNamespace}/${RoyaltyAccountsMainContacts.SET.ALL}`,
  label_artist: `${CatalogStoreNamespace}/${ArtistRelatedContacts.SET.ALL}`,
  label: `${CatalogStoreNamespace}/${LabelRelatedContacts.SET.ALL}`,
  project: `${CatalogStoreNamespace}/${ProjectRelatedContacts.SET.ALL}`,
  licence_account: `${LicenceStoreNamespace}/${LicenceAccountRelatedContacts.SET.ALL}`,

  l_statements: `${DistributionStoreNamespace}/${DistributionContact.SET.ALL}`,
  supplier: `${DistributionStoreNamespace}/${SupplierRelatedContacts.SET.ALL}`,

  account: `${DistributionStoreNamespace}/${DistributionAccountRelatedContacts.SET.ALL}`,

  //invoice_contact
  RoyaltyAccountsInvoiceConfig: `${RoyaltyStoreNamespace}/${RoyaltyAccountsMainContacts.SET.ALL}`,
  AccountingCostsInvoiceConfig: `${AccountingStoreNamespace}/${AccountingCostsContacts.SET.ALL}`,
  DistributionOrderInvoiceConfig: `${DistributionStoreNamespace}/${DistributionOrderInvoiceContact.SET.ALL}`,
  LicenceAccountInvoiceConfig: `${LicenceStoreNamespace}/${LicenceInvoiceContact.SET.ALL}`,
  DistributionOrderDeliveryConfig: `${DistributionStoreNamespace}/${DistributionOrderDeliveryAddress.SET.ALL}`,
  DistributionAccountInvoiceConfig: `${DistributionStoreNamespace}/${DistributionAccountInvoiceContact.SET.ALL}`,
  DistributionAccountDeliveryConfig: `${DistributionStoreNamespace}/${DistributionAccountDeliveryAddress.SET.ALL}`,
  DistributionSupplierInvoiceConfig: `${DistributionStoreNamespace}/${DistributionSupplierInvoiceContact.SET.ALL}`,
  DistributionSupplierDeliveryConfig: `${DistributionStoreNamespace}/${DistributionSupplierDeliveryAddress.SET.ALL}`



};

export const getContactRelationAddedAction = key => {
  const action = AddContactRelationDict[key];
  console.log("action", action)
  if (action) {
    return action;
  } else {
    throw Error("No Action Found in Dict");
  }
};

export const ConfigDict = {
  account: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "account",
    ...contactSearchGetters(ContactSearchTypes.BOTH)
  },
  order: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "order",
    ...contactSearchGetters(ContactSearchTypes.BOTH)
  },
  artists: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "artists",
    ...contactSearchGetters(ContactSearchTypes.BOTH)
  },
  calendar_dates: {
    contactSearchType: ContactSearchTypes.INDIVIDUAL,
    templateType: "calendar_dates",
    ...contactSearchGetters(ContactSearchTypes.INDIVIDUAL)
  },
  booking_locations: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH)
  },
  contacts_individual: {
    contactSearchType: ContactSearchTypes.COMPANY,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.COMPANY)
  },
  contacts: {
    contactSearchType: ContactSearchTypes.INDIVIDUAL,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.INDIVIDUAL)
  },
  release: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH)
  },
  royalty_account: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH)
  },

  label_artist: {
    contactSearchType: ContactSearchTypes.INDIVIDUAL,
    templateType: "standerd",
    ...contactSearchGetters(ContactSearchTypes.INDIVIDUAL)
  },
  label: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standerd",
    ...contactSearchGetters(ContactSearchTypes.INDIVIDUAL)
  },
  project: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standerd",
    ...contactSearchGetters(ContactSearchTypes.INDIVIDUAL)
  },

  licence_account: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standerd",
    ...contactSearchGetters(ContactSearchTypes.COMPANY)

  },


  l_royalty_accounts: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH),


  },

  l_statements: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH),


  },
  supplier: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH),


  },

  RoyaltyAccountsInvoiceConfig: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH),


  },
  LicenceAccountInvoiceConfig: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH),


  },
  DistributionOrderDeliveryConfig: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH),


  },

  DistributionOrderInvoiceConfig: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH),
  },
  AccountingCostsInvoiceConfig: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH),
  },
  DistributionAccountInvoiceConfig: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH),
  },

  DistributionAccountDeliveryConfig: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH),
  },

  DistributionSupplierInvoiceConfig: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH),
  },

  DistributionSupplierDeliveryConfig: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH),
  }


};
export const getContactRelationConfiguration = key => {
  const config = ConfigDict[key];
  if (config) {
    return config;
  } else {
    throw Error("No Config Found in Dict");
  }
};

export const relatedContactSetPayload = () => {
  return {
    contact_relations,
    external_table,
    external_id
  };
};
